import classes from "./style.module.scss";

const Footer = () => {
	return (
		<div className={classes["container"]} style={customStyle.MyAccountFooter}>
			<div className={classes["footer"]}>
				<div className={classes["item-list"]}>
					<p><a href="https://modus.org/about" target="_blank" rel="noreferrer">
						About
					</a></p>
					<p><a
						href="https://modus.org/disclaimer"
						target="_blank"
						rel="noreferrer"
					>
						Disclaimer
					</a></p>
					<p><a
						href="https://modus.org/about#contact"
						target="_blank"
						rel="noreferrer"
					>
						Contact us
					</a>{" "}</p>
					<p><a href="https://modus.org/about" target="_blank" rel="noreferrer">
						FAQ
					</a></p>
				</div>
				<div className={classes["item"]}>
					<span>
						<a href="https://modus.org" target="_blank" rel="noreferrer">
							{" "}
							Modus &#64; 2026{" "}
						</a>
						<br />
					</span>
					<span>
						<a
							href="https://www.privacypolicies.com/live/2dfc4390-0bb4-4018-87a6-0d33bddf8421"
							target="_blank"
							rel="noreferrer"
						>
							Privacy policy
						</a>{" "}
						-{" "}
						<a
							href="https://modus.org/terms-and-conditions/?_gl=1*4nrxkx*_ga*OTQ5OTg4MjU5LjE3MzU5MDM3Njc.*_ga_H1FL6L6JH5*MTczNjMxMTMzMi4yLjEuMTczNjMxMTQzMy4wLjAuMA"
							target="_blank"
							rel="noreferrer"
						>
							Terms and Condiitions
						</a>
					</span>
				</div>
			</div>
		</div>
	);
};

export default Footer;

const customStyle = {
	MyAccountFooter: {
		position: "fixed",
		bottom: "0px",
		right: "0px",
		width: "auto",
		left: "14.875rem"
	}
}